// 表单的一些标准化格式化功能函数

export const trim = value => {
  // console.log(`trim normalize =${value}=`);
  return value && value.trim();
};
